import React from 'react';
import { Icon } from './Icon.js';
export const IconBox3 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M6.45084 4.76019L17.8905 11", stroke: "currentColor", strokeWidth: "2", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M13 14V22", stroke: "currentColor", strokeWidth: "2", fill: "none" }),
        React.createElement("path", { d: "M22 8.5L13 14L2 8", stroke: "currentColor", strokeWidth: "2", fill: "none" }),
        React.createElement("path", { d: "M22 8V16.5L13 22L2 16V7.5L11 2L22 8Z", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", fill: "none" })));
};
//# sourceMappingURL=IconBox3.js.map